import { useCallback, useEffect, useState, type ReactElement } from 'react';
import {
  CANVAS_SITE_ACTIONS_PANEL_EVENT as SITE_ACTIONS_PANEL_EVENT_EXPORT,
  getEditor,
  type CanvasSiteActionsPanelEventDetail,
} from 'agentable-canvas/whiteboard';
import { SiteActionsBar } from './SiteActionsBar';

const CANVAS_SITE_ACTIONS_PANEL_EVENT =
  SITE_ACTIONS_PANEL_EVENT_EXPORT ?? 'landi-canvas-site-actions-panel';

/** Bridges tldraw site-actions overflow tool to the host publish/edit bar. */
export function SiteActionsBridge(): ReactElement | null {
  const [panelOpen, setPanelOpen] = useState(false);

  useEffect(() => {
    const handler = (event: Event): void => {
      const detail = (event as CustomEvent<CanvasSiteActionsPanelEventDetail>).detail;
      if (!detail || typeof detail.open !== 'boolean') return;
      setPanelOpen(detail.open);
    };
    window.addEventListener(CANVAS_SITE_ACTIONS_PANEL_EVENT, handler);
    return () => window.removeEventListener(CANVAS_SITE_ACTIONS_PANEL_EVENT, handler);
  }, []);

  const onDismiss = useCallback((): void => {
    const editor = getEditor();
    if (editor?.getCurrentToolId() === 'site-actions') {
      editor.setCurrentTool('select');
      return;
    }
    setPanelOpen(false);
  }, []);

  return <SiteActionsBar open={panelOpen} onDismiss={onDismiss} />;
}
